import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=62bc5b32&scoped=true&"
import script from "./TermsOfService.vue?vue&type=script&lang=ts&"
export * from "./TermsOfService.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=62bc5b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bc5b32",
  null
  
)

export default component.exports